import { Controller } from "@hotwired/stimulus";

export default class OverflowDetector extends Controller {
	connect() {
		this.element.addEventListener("scroll", this.updateOverflow, { passive: true });
		window.addEventListener("resize", this.updateOverflow);

		this.updateOverflow();
	}

	disconnect() {
		this.element.removeEventListener("scroll", this.updateOverflow);
		window.removeEventListener("resize", this.updateOverflow);
	}

	updateOverflow = () => {
		const { scrollLeft, scrollWidth, clientWidth } = this.element;
		this.element.classList.toggle("overflows-left", scrollLeft > 0);

		this.element.classList.toggle(
			"overflows-right",
			scrollLeft + clientWidth < scrollWidth - 1
		);
	};
}
